import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withContent from '../../../../containers/withContent';
import { withScrollTop } from '../../../../containers/withScrollTop';
import {
	getBacsDetailsWithAccounts,
	getAuthorisationType,
	getConfirmationRequiresAuthorisation,
	getBacsPaymentError,
	getBacsCreditAuthorisers,
} from '../../../../states/bacsCredit/selectors';
import CreditSummary from '../../BacsSummary/CreditSummary/CreditSummary';
import creditSubmittedContent, { contentPropTypes } from './CreditSubmitted.content';
import CreditTable from '../../BacsTable/CreditTable/CreditTable';
import BacsSubmittedPage from '../BacsSubmittedPage';
import { getUserId } from '../../../../states/user/selectors';

const mapState = (state) => ({
	bacsDetails: getBacsDetailsWithAccounts(state),
	authRequired: getConfirmationRequiresAuthorisation(state),
	authType: getAuthorisationType(state),
	paymentError: getBacsPaymentError(state),
	authorisers: getBacsCreditAuthorisers(state),
	userId: getUserId(state),
});
const renderBacsTable = () => <CreditTable />;
const renderBacsSummary = () => <CreditSummary />;

const CreditSubmittedPage = ({
	content,
	bacsDetails,
	handleRoute,
	handleReset,
	authRequired,
	authType,
	paymentError,
	authorisers,
	userId,
}) => (
	<BacsSubmittedPage
		content={content}
		renderBacsTable={renderBacsTable}
		renderBacsSummary={renderBacsSummary}
		bacsDetails={bacsDetails}
		handleRoute={handleRoute}
		handleReset={handleReset}
		authRequired={authRequired}
		authType={authType}
		paymentError={paymentError}
		authorisers={authorisers}
		userId={userId}
	/>
);

CreditSubmittedPage.propTypes = {
	paymentError: PropTypes.shape({}),
	bacsDetails: PropTypes.shape({}).isRequired,
	content: PropTypes.shape(contentPropTypes).isRequired,
	handleRoute: PropTypes.func.isRequired,
	handleReset: PropTypes.func.isRequired,
	authRequired: PropTypes.bool.isRequired,
	authType: PropTypes.string.isRequired,
	authorisers: PropTypes.arrayOf(PropTypes.shape({})),
};

export const ConnectWrapper = connect(mapState)(CreditSubmittedPage);
const contentWrapper = withContent({ content: creditSubmittedContent });
export default connect(mapState)(withScrollTop(contentWrapper(CreditSubmittedPage)));
